var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.badgeCls},[_vm._t("default"),_vm._v(" "),(_vm.dot || _vm.text)?_c('sup',{class:_vm.scrollNumberCls,style:(_vm.styles)},[_vm._v(_vm._s(_vm.currentText))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60edb6c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/badge/badge.vue
// module id = null
// module chunks = 